import { render, staticRenderFns } from "./list-clinics.vue?vue&type=template&id=69e03b97&"
import script from "./list-clinics.vue?vue&type=script&lang=js&"
export * from "./list-clinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports